import { createAsyncThunk } from '@reduxjs/toolkit';
import { heroApiService } from '@services/.';
import { ExtraReducer, getSideEffectState } from '@utils/.';
import { LocationReducerProps } from '../type';

export const fetchXeroInfo = createAsyncThunk('business/fetchXeroInfo', async (_, thunkApi) => {
  try {
    const xeroInfo = await heroApiService.getLocationXeroInfo();
    return xeroInfo;
  } catch (error: any) {
    return undefined;
  }
});

const [fulfilled, pending, rejected] = getSideEffectState(fetchXeroInfo);

export const fetchXeroInfoReducer = {
  [fulfilled]: (state, action) => {
    state.isLoading = false;
    state.integration.xero = action.payload;
  },
  [rejected]: (state, action) => {
    state.isLoading = false;
    state.integration.xero = undefined;
  },
  [pending]: (state, action) => {
    state.isLoading = true;
  },
} as ExtraReducer<LocationReducerProps>;
